import { React, useEffect, useState } from "react";
import { AddCategoriesWrapper } from "../ProductsPage.styled";
import {
	AddCatButton,
	HeaderButton,
	HeaderWrapper,
	CategoryContainer,
	SubsectionsHeader,
	SubSectionsWrapper,
	SubCategoryButton,
	// EditButton,
	// SubCategoriesWrapper,
	// SubContent,
	ViewSubCategory,
} from "./ProductCategories.styled";
import addIcon from "../../../assets/icons/addCart.svg";
import { IoIosArrowBack } from "react-icons/io";
import editIcon from "../../../assets/icons/editCatIcon.svg";
import Parse from "../../../api/ApiConfig";
import { Backdrop, CircularProgress } from "@mui/material";
import FormDialog from "../../../components/ReusableComponents/FormDialog";
import { toast } from "react-toastify";
import { FaRegEye } from "react-icons/fa";
import { singularize } from "../ProductUtils/CategoriesUtils";
import ConfirmModal from "../../../components/ConfirmModal";
import {
	deleteCategory,
	deleteSubcategory,
	deleteBrand,
	deleteModel,
	editBrandName,
	editModelName,
	Capitalize,
} from "../ProductUtils/CategoriesUtils";
import { RiDeleteBin6Line } from "react-icons/ri";
import { canPerformAction } from "../../../utils/UserAuth";

// import { Link, Outlet } from 'react-router-dom';

function ProductCategories() {
	const [allCategories, setAllCategories] = useState([]);
	const [isSubCategory, setIsSubCategory] = useState(false);
	const [subSectionsData, setsubSectionsData] = useState([]);
	const [CategoriesTitle, setCategoriesTitle] = useState();
	const [subCategoryId, setSubcategoryId] = useState();
	const [modelId, setModelId] = useState();
	// eslint-disable-next-line no-unused-vars
	const [currentCatId, setCurrentCatId] = useState();

	//dialog states
	const [loading, setLoading] = useState(true);
	const [openDialog, setOpenDialog] = useState(false);
	const [text, setText] = useState("");
	const [label, setLabel] = useState("");
	const [formData, setFormData] = useState("");
	const [modalType, setModalType] = useState("");
	const [currentBrand, setCurrentBrand] = useState();
	const [currentModel, setCurrentModel] = useState();
	const [currentCategory, setCurrentCategory] = useState();
	const [currentHeading, setCurrentHeading] = useState();
	const [guide, setGuide] = useState();
	const [presentCategory, setPresentCategory] = useState();
	const [action, setAction] = useState();

	//delete dialog states
	const [confirmModal, setConfirmModal] = useState(false);
	const [deletedData, setDeleteData] = useState("");
	// const [brandName, setBrandName] = useState();

	//to be refactored

	useEffect(() => {
		fetchAllCategories();
		setLoading(false);
	}, []);

	const fetchAllCategories = async () => {
		const Category = Parse.Object.extend("Category");
		const query = new Parse.Query(Category);

		try {
			const categories = await query.find();

			if (!categories || categories.length === 0) {
				toast.error("No categories found!");
				return [];
			}

			const uniqueCategories = [];
			const categoryMap = {};

			categories.forEach((category) => {
				const categoryId = category.id;
				const categoryName = category.get("categoryName");

				if (!categoryMap[categoryName]) {
					categoryMap[categoryName] = categoryId;
					uniqueCategories.push({ id: categoryId, name: categoryName });
				}
			});
			setAllCategories(uniqueCategories);
		} catch (error) {
			toast.error("Error fetching data");
			setAllCategories([]);
		}
	};

	const setSubCategory = (category, categoryId) => {
		setCurrentCatId(categoryId);
		// console.log(categoryId)
		fetchSubCategories(category);
		setIsSubCategory(!isSubCategory);
	};
	// Get a list of all Sub-categories of a category
	const fetchSubCategories = async (category) => {
		setLoading(true);
		setCategoriesTitle("Categories");
		setCurrentCategory(category);
		setGuide("sub-categories");
		setCurrentHeading(category);
		const Category = Parse.Object.extend("Category");
		const query = new Parse.Query(Category);
		query.equalTo("categoryName", category);
		try {
			const category = await query.find();
			if (!category) {
				toast.error("No sub Category");
				return;
			}
			// console.log(category);
			const subCategories = category.map((cat) => {
				return {
					name: cat.get("subCategory"),
					id: cat.id,
				};
			});

			setsubSectionsData(subCategories);
			setLoading(false);
		} catch (error) {
			setLoading(false);
			toast.error(error.message);
		}
	};

	//subcategoryid, name and categoryid
	const fetchBrandAndModel = async (id, name, catId) => {
		// console.log(id, name, catId)
		if (CategoriesTitle === "Sub-Categories") {
			fetchModels(name, catId);
			return;
		} else if (CategoriesTitle === "Brands") {
			// alert("list of brands available");
			//summarizes the state management of the whole flow
			setsubSectionsData([{ name: name, id: id, catId: catId }]);
			setCategoriesTitle("Models");
			setCurrentHeading(name);
			setGuide("item");
			setModelId(id);
			setLoading(false);
		} else if (CategoriesTitle === "Categories") {
			fetchBrands(id, name);
			setSubcategoryId(id);
		}
	};

	const fetchBrands = async (id, name) => {
		setCurrentBrand({ name: name, id: id });
		setLoading(true);
		setCurrentHeading(name);
		setGuide("Brands");
		setCategoriesTitle("Sub-Categories"); //set navigation title

		//fetch brand
		const Brand = Parse.Object.extend("Brand");
		const query = new Parse.Query(Brand);
		query.equalTo("categoryId", id);

		try {
			const category = await query.find();
			if (!category || category.length === 0) {
				toast.error("Category does not exist!");
				setLoading(false);
			}

			const brands = category.map((cat) => ({
				name: cat.get("brand"),
				categoryId: cat.get("categoryId"),
				id: cat.id,
			}));
			const uniqueBrands = [...new Set(brands.map((brand) => brand.name))];
			const allBrands = uniqueBrands.map((brand) => {
				const brandObj = brands.find((b) => b.name === brand);
				return { name: brand, catId: brandObj.categoryId };
			});

			setsubSectionsData(allBrands);
			setLoading(false);
		} catch (error) {
			toast.error(error.message);
			setLoading(false);
		}
	};

	const fetchModels = async (name, catId) => {
		console.log(name, catId);
		setCurrentModel({ name: name, catId: catId });
		setLoading(true);
		setCategoriesTitle("Brands");
		setGuide("Models");
		setCurrentHeading(name);

		// Get a list of all models of a brand in a specific sub-category
		const Brand = Parse.Object.extend("Brand");
		const query = new Parse.Query(Brand);
		query.equalTo("categoryId", catId); // Id of the category/sub-category
		query.equalTo("brand", name);

		try {
			const brands = await query.find();
			if (!brands || brands.length === 0) {
				toast.error("Unable to fetch models");
			}

			const models = brands.map((brand) => {
				return {
					id: brand.id, // Include the 'id' property
					name: brand.get("model"),
				};
			});

			// console.log(brands);
			setsubSectionsData(models);
			setLoading(false);
			// return models
		} catch (error) {
			setLoading(false);
			toast.error(error.message);
		}
	};

	//create new categories
	const createNewCategory = async (data) => {
		let categoryDetails = { categoryName: Capitalize(data.category) };

		setLoading(true);
		try {
			const response = await fetch(
				`${Parse.serverURL}/functions/createCategory`,
				{
					method: "POST",
					headers: { "X-Parse-Application-Id": process.env.REACT_APP_APP_ID },
					body: JSON.stringify(categoryDetails),
				}
			);
			const res = await response.json();
			console.log(res);
			if (res.error) {
				toast.error(res.error);
				setFormData("");
				setLoading(false);
			} else {
				toast.success("New Category added");
				setFormData("");
				fetchAllCategories();
				setLoading(false);
			}
		} catch (error) {
			toast.error(
				"Unable to add New Category,  Please check your internet connection and try again"
			);
			setFormData("");
			setLoading(false);
		}
	};

	const createSubCategory = async (data) => {
		let subcategoryDetails = {
			categoryName: currentHeading,
			subCategory: Capitalize(data.category),
		};

		setLoading(true);
		try {
			const response = await fetch(
				`${Parse.serverURL}/functions/createSubCategory`,
				{
					method: "POST",
					headers: { "X-Parse-Application-Id": process.env.REACT_APP_APP_ID },
					body: JSON.stringify(subcategoryDetails),
				}
			);
			const res = await response.json();
			if (res.error) {
				toast.error(res.error);
				setLoading(false);
				setFormData("");
			} else {
				setLoading(false);
				toast.success("New Sub-Category added");
				fetchSubCategories(currentHeading);
				setFormData("");
			}
		} catch (error) {
			console.log(error);
			setLoading(false);
			toast.error(
				"Unable to add New sub-category, Please check your internet connection and try again"
			);
			setFormData("");
		}
	};

	const createNewBrand = async (data) => {
		let brandDetails = {
			subCategory: currentBrand.id,
			brand: Capitalize(data.category),
		};

		setLoading(true);
		try {
			const response = await fetch(`${Parse.serverURL}/functions/createBrand`, {
				method: "POST",
				headers: { "X-Parse-Application-Id": process.env.REACT_APP_APP_ID },
				body: JSON.stringify(brandDetails),
			});
			const res = await response.json();
			if (res.error) {
				toast.error(res.error);
				setLoading(false);
				setFormData("");
			} else {
				setLoading(false);
				toast.success("New Brand added");
				fetchBrands(currentBrand.id, currentBrand.name);
				setFormData("");
			}
		} catch (error) {
			console.log(error);
			setLoading(false);
			toast.error(
				"Unable to add new brand, Please check your internet connection and try again"
			);
			setFormData("");
		}
	};

	const createNewModel = async (data) => {
		let modelDetails = {
			brand: currentHeading,
			categoryId: currentBrand.id,
			model: Capitalize(data.category),
		};
		// console.log(modelDetails);
		setLoading(true);
		try {
			const response = await fetch(`${Parse.serverURL}/functions/createModel`, {
				method: "POST",
				headers: { "X-Parse-Application-Id": process.env.REACT_APP_APP_ID },
				body: JSON.stringify(modelDetails),
			});
			const res = await response.json();
			if (res.error) {
				toast.error(res.error);
				setLoading(false);
				setFormData("");
			} else {
				toast.success("New Model added");
				fetchModels(currentHeading, currentBrand.id);
				setFormData("");
				setLoading(false);
			}
		} catch (error) {
			console.log(error);
			setLoading(false);
			toast.error(
				"Unable to add new Model, Please check your internet connection and try again"
			);
			setFormData("");
		}
	};

	//close edit dialog
	const handleClose = () => {
		setOpenDialog(false);
	};

	//open edit modal
	const openModal = (text, label, type, nameOfCategory) => {
		setText(text);
		setLabel(label);
		setOpenDialog(true);
		setModalType(type);
		if (nameOfCategory) {
			setPresentCategory(nameOfCategory);
			setAction("Edit");
		} else {
			setAction("Add");
		}
	};

	//call save function after clicking yes in edit dialog
	const handleYes = (data) => {
		// console.log(modalType);
		if (!data) {
			toast.error("Field cannot be blank!");
			setFormData("");
			return;
		}
		// console.log(modalType);
		// switch statement
		if (modalType === "addCategory") {
			createNewCategory(data);
		} else if (modalType === "sub-categories") {
			createSubCategory(data);
		} else if (modalType === "Brands") {
			createNewBrand(data);
		} else if (modalType === "Models") {
			createNewModel(data);
		} else if (modalType === "editCategory") {
			editCategoryName(data);
		} else if (modalType === "editSub-Category") {
			editSubCategory(data);
		} else if (modalType === "editBrand") {
			editBrandNameHandler(data);
		} else if (modalType === "editModel") {
			editModelHandler(data);
		}
		setOpenDialog(false);
		return;
	};

	const prevsBtnHandler = () => {
		if (CategoriesTitle === "Categories") {
			setIsSubCategory(false);
		} else if (CategoriesTitle === "Sub-Categories") {
			setCategoriesTitle("Categories");
			fetchSubCategories(currentCategory);
			return;
		} else if (CategoriesTitle === "Brands") {
			setCategoriesTitle("Sub-Categories");
			fetchBrands(currentBrand.id, currentBrand.name);
			return;
		} else if (CategoriesTitle === "Models") {
			setCategoriesTitle("Brands");
			fetchModels(currentModel.name, currentModel.catId);
			return;
		}
	};

	//edit functions
	const editCategoryName = async (data) => {
		setLoading(true);
		// console.log(data);
		const Category = Parse.Object.extend("Category");
		const query = new Parse.Query(Category);
		query.equalTo("categoryName", presentCategory);
		try {
			const categories = await query.find();
			for (const category of categories) {
				category.set("categoryName", Capitalize(data.category));
				await category.save();
			}
			setFormData("");
			toast.success("Category name updated successfully");
			fetchAllCategories();
			setLoading(false);
		} catch (error) {
			toast.error("Error updating category name:", error.message);
			setFormData("");
			setLoading(false);
		}
	};

	const editSubCategory = async (data) => {
		// console.log(currentCategory, currentHeading, data.category )
		setLoading(true);
		const Category = Parse.Object.extend("Category");
		const query = new Parse.Query(Category);
		query.equalTo("categoryName", currentCategory);
		query.equalTo("subCategory", currentHeading);

		try {
			const categories = await query.find();
			for (const category of categories) {
				category.set("subCategory", Capitalize(data.category));
				await category.save();
			}
			setFormData("");
			setLoading(false);
			fetchSubCategories(currentCategory); //fetch updated sub-categories
			toast.success("Sub-category updated successfully");
		} catch (error) {
			setFormData("");
			setLoading(false);
			toast.error("Error updating sub-category:", "Please try again later");
		}
	};

	const editBrandNameHandler = async (data) => {
		setLoading(true);
		editBrandName(currentBrand.id, currentHeading, Capitalize(data.category))
			.then((response) => {
				if (response.length <= 0) {
					toast.error("Unable to update brand name");
					setLoading(false);
				} else {
					setLoading(false);
					setFormData("");
					toast.success("Brand name updated successfully");
					fetchBrands(currentBrand.id, currentHeading);
				}
			})
			.catch((error) => {
				toast.error(error);
				setLoading(false);
				setFormData("");
			});
	};

	const editModelHandler = (data) => {
		setLoading(true);
		// console.log(subCategoryId, currentModel.name, currentHeading, data.category)
		editModelName(
			subCategoryId,
			currentModel.name,
			currentHeading,
			Capitalize(data.category)
		)
			.then((response) => {
				if (response.length <= 0) {
					toast.error("Unable to update model ");
					// console.log(response);
					setLoading(false);
				} else {
					setLoading(false);
					setFormData("");
					toast.success("Model  updated successfully");
					fetchModels(currentModel.name, currentModel.catId);
				}
			})
			.catch((error) => {
				toast.error(error);
				setLoading(false);
				setFormData("");
			});
	};

	const handleDeleteAction = () => {
		setConfirmModal(false);
		handleDeleteData();
	};

	const openDeleteModal = (data, section) => {
		setConfirmModal(true);
		//store data and current state of the applcation
		setDeleteData({ data: data, currentState: section });
	};

	const handleDeleteData = () => {
		// console.log(deletedData.currentState);
		if (deletedData.currentState === "category") {
			deleteCategory(deletedData.data)
				.then((response) => {
					if (response.error) {
						toast.error(response.error);
					} else {
						toast.success("Item successfully deleted");
						fetchAllCategories();
						// console.log(response);
						setDeleteData("");
					}
				})
				.catch((error) => {
					toast.error(error.message);
					console.log(error);
				});
		} else if (deletedData.currentState === "Sub-Category") {
			deleteSubcategory(subCategoryId)
				.then((response) => {
					if (response.error) {
						toast.error(response.error);
					} else {
						toast.success("Item successfully deleted");
						//change currentCategory to currentSubcategory
						fetchSubCategories(currentCategory); //fetch updated sub-categories
						// console.log(currentCategory);
						setDeleteData("");
					}
				})
				.catch((error) => {
					toast.error(error.message);
					console.log(error);
				});
		} else if (deletedData.currentState === "Brand") {
			deleteBrand(currentBrand.id, currentHeading)
				.then((response) => {
					if (response.error) {
						toast.error(response.error);
					} else {
						toast.success("Item successfully deleted");
						fetchBrands(currentBrand.id, currentHeading);
						setDeleteData("");
					}
				})
				.catch((error) => {
					toast.error(error.message);
					console.log(error);
				});
		} else if (deletedData.currentState === "Model") {
			deleteModel(modelId)
				.then((response) => {
					if (response.error) {
						toast.error(response.error);
					} else {
						toast.success("Item successfully deleted");
						fetchModels(currentModel.name, currentModel.catId);
						setDeleteData("");
					}
				})
				.catch((error) => {
					toast.error(error.message);
					console.log(error);
				});
		}
	};

	{
		/* eslint-disable no-mixed-spaces-and-tabs  */
	}
	return (
		<AddCategoriesWrapper>
			<FormDialog
				openDialog={openDialog}
				handleClose={handleClose}
				text={text}
				label={label}
				setFormData={setFormData}
				action={action}
				handleYes={() => handleYes(formData)}
			/>
			{confirmModal && (
				<ConfirmModal
					confirmModal={confirmModal}
					setConfirmModal={setConfirmModal}
					content={{
						title: "Warning!",
						desc: "This action cannot be reversed. Are you sure you want to delete?",
						btnText: "Yes, Delete",
					}}
					type='categories'
					handleDeleteAction={handleDeleteAction}
				/>
			)}
			{loading && (
				<Backdrop
					sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
					open={loading}
					onClick={() => setLoading(false)}
				>
					<CircularProgress color='inherit' />
				</Backdrop>
			)}
			{!isSubCategory ? (
				<>
					{canPerformAction("edit", "products") && (
						<AddCatButton
							onClick={() =>
								openModal(
									"Add new Category",
									"New Category Name",
									"addCategory"
								)
							}
							type='large'
						>
							<img className='' src={addIcon} />
							<p>Add new category</p>
						</AddCatButton>
					)}

					<HeaderWrapper>
						{allCategories.length > 0 ? (
							allCategories.map((item) => {
								return (
									<CategoryContainer key={item.id}>
										<HeaderButton>{item.name}</HeaderButton>
										<ViewSubCategory
											onClick={() => setSubCategory(item.name, item.id)}
										>
											<FaRegEye /> view sub-categories
										</ViewSubCategory>
										{canPerformAction("edit", "products") && (
											<ViewSubCategory
												onClick={() =>
													openModal(
														"Edit category name",
														"New Category Name",
														"editCategory",
														item.name
													)
												}
											>
												<img style={{ height: ".7rem" }} src={editIcon} />
												Change name
											</ViewSubCategory>
										)}

										{canPerformAction("edit", "products") && (
											<ViewSubCategory
												type={"delete"}
												onClick={() => openDeleteModal(item.name, "category")}
											>
												<RiDeleteBin6Line size={15} />
												Delete
											</ViewSubCategory>
										)}
									</CategoryContainer>
								);
							})
						) : (
							<p>Categories not available, try again later</p>
						)}
					</HeaderWrapper>
				</>
			) : (
				<SubSections
					currentHeading={currentHeading}
					subSectionsData={subSectionsData}
					CategoriesTitle={CategoriesTitle}
					fetchBrandAndModel={fetchBrandAndModel}
					guide={guide}
					prevsBtnHandler={prevsBtnHandler}
					singularize={singularize}
					// currentBrand={currentBrand}
					// createSubCategory={createSubCategory}
					openModal={openModal}
					openDeleteModal={openDeleteModal}
				/>
			)}
		</AddCategoriesWrapper>
	);
}

/* eslint-disable react/prop-types */
export function SubSections({
	// placeHolder,
	subSectionsData,
	CategoriesTitle,
	fetchBrandAndModel,
	openModal,
	openDeleteModal,
	guide,
	prevsBtnHandler,
	singularize,
	// currentBrand,
	currentHeading,
	// createSubCategory,
}) {
	return (
		<SubSectionsWrapper>
			<SubsectionsHeader onClick={prevsBtnHandler}>
				<IoIosArrowBack size={24} />
				{CategoriesTitle}
			</SubsectionsHeader>
			<CategoryContainer>
				<HeaderButton>{currentHeading}</HeaderButton>
				{canPerformAction("edit", "products") &&
				(CategoriesTitle === "Categories" ? null : (
					<>
						<ViewSubCategory
							onClick={() =>
								openModal(
									`Edit ${singularize(CategoriesTitle)} name`,
									`New ${singularize(CategoriesTitle)} name`,
									`edit${singularize(CategoriesTitle)}`,
									`edit${singularize(CategoriesTitle)}`
								)
							}
						>
							<img style={{ height: ".7rem" }} src={editIcon} />
							Change name
						</ViewSubCategory>

						<ViewSubCategory
							type={"delete"}
							onClick={() =>
								openDeleteModal(
									CategoriesTitle,
									`${singularize(CategoriesTitle)}`
								)
							}
						>
							<RiDeleteBin6Line size={15} />
							{/* <img style={{ height: ".7rem" }} src={editIcon} /> */}
							Delete
						</ViewSubCategory>
					</>
				))}
			</CategoryContainer>
			<p className="fw-600">{guide}</p>
			<CategoryContainer>
				{/* eslint-disable no-mixed-spaces-and-tabs  */}
				{subSectionsData.length > 0
					? subSectionsData.map((item) => {
							return (
								<SubCategoryButton
									onClick={() =>
										fetchBrandAndModel(item.id, item.name, item.catId)
									}
									key={item.id || item.name}
								>
									{item.name}
								</SubCategoryButton>
							);
					  })
					: null}
				{canPerformAction("edit", "products") &&
					(CategoriesTitle === "Models" ? null : (
						<AddCatButton
							type='small'
							onClick={() =>
								openModal(
									`Add new ${singularize(guide)}`,
									`New ${singularize(guide)} name`,
									`${guide}`
								)
							}
						>
							<img className='' src={addIcon} />
							<p>Add new {singularize(guide)}</p>
						</AddCatButton>
					))}
			</CategoryContainer>
		</SubSectionsWrapper>
	);
}
export default ProductCategories;
